import React from 'react';
import Card from '../common/Card';
import Badge from '../common/Badge';
import SafeIcon from '../../common/SafeIcon';
import { format } from 'date-fns';
import { motion } from 'framer-motion';

const AuditLogView = ({ logs }) => {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="space-y-6">
      <div className="flex justify-between items-end mb-6">
        <div>
          <h2 className="text-2xl font-bold text-white tracking-tight">Audit Log</h2>
          <p className="text-gray-400 mt-1">Immutable record of system and user actions.</p>
        </div>
        <button className="flex items-center gap-2 text-sm text-gray-400 hover:text-white transition-colors">
          <SafeIcon name="Download" /> Export CSV
        </button>
      </div>

      <Card>
        <div className="relative">
          {/* Vertical line connecting events */}
          <div className="absolute left-6 top-4 bottom-4 w-px bg-sp-gray-800"></div>
          
          <div className="space-y-6 relative z-10 p-2">
            {logs.map((log, idx) => {
              const date = new Date(log.timestamp);
              
              let icon = 'Activity';
              let iconColor = 'text-gray-400';
              let bgIconColor = 'bg-sp-gray-800';

              if (log.action.includes('SYNC')) { icon = 'RefreshCw'; iconColor = 'text-sp-cyan'; }
              if (log.action.includes('ADJUST')) { icon = 'Edit2'; iconColor = 'text-orange-400'; }
              if (log.action.includes('PO_')) { icon = 'Truck'; iconColor = 'text-sp-lime'; }

              return (
                <motion.div 
                  initial={{ opacity: 0, x: -10 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: idx * 0.1 }}
                  key={log.id} 
                  className="flex gap-4"
                >
                  <div className={`w-8 h-8 rounded-full ${bgIconColor} border border-sp-gray-700 flex items-center justify-center shrink-0 mt-1 shadow-md`}>
                    <SafeIcon name={icon} className={`text-sm ${iconColor}`} />
                  </div>
                  
                  <div className="bg-sp-gray-900/50 border border-sp-gray-800 rounded p-3 flex-1 hover:border-sp-gray-700 transition-colors">
                    <div className="flex flex-wrap justify-between items-start gap-2 mb-2">
                      <div className="flex items-center gap-2">
                        <Badge variant="default" className="font-bold">{log.action}</Badge>
                        <span className="text-xs text-gray-500 font-mono">{log.id}</span>
                      </div>
                      <div className="text-xs text-gray-500 font-mono text-right">
                        {format(date, 'MMM dd, yyyy HH:mm:ss')}
                      </div>
                    </div>
                    
                    <p className="text-sm text-gray-300">{log.details}</p>
                    
                    <div className="mt-2 text-xs text-gray-500 flex items-center gap-1">
                      <SafeIcon name="User" className="text-[10px]" />
                      {log.user}
                    </div>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </Card>
    </motion.div>
  );
};

export default AuditLogView;